// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentFragmentDoc } from '../CmsComponent.fragment.generated';
export const ComponentGlobalComponentFragmentDoc = gql`
    fragment componentGlobalComponent on ComponentGlobalComponent {
  backgroundColor
  components {
    ...component
  }
}
    ${ComponentFragmentDoc}`;